// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VH6Ie","label":"styles_label__2Otpa"};